<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="test-issuings"
            dusk="test-issuings-table"
            :items="testIssuings"
            :fields="fields"
            :show-empty="true">
            <template v-slot:options>
                <b-button
                    class="btn-add"
                    variant="primary"
                    @click="navigateToTestIssuingWizard"
                    dusk="issue-test-button">
                    {{$t('testcenter.hand_out_test')}}
                </b-button>
            </template>

            <template v-slot:cell(created_at)="data">
                {{ data.item.created_at | date_time_named_month }}
            </template>

            <template v-slot:cell(teacher)="data">
                {{ data.item.teachers[0].full_name }}
            </template>

            <template v-slot:cell(responses)="data">
                <div class="users-list">
                    <i
                        class="fad fa-users icon"
                        v-if="data.item.responses.length > 0"
                        :id="`popover-students-overview-${data.item.id}`">
                    </i>

                    <b-popover
                        custom-class="apprentice-popover popover-student-overview"
                        :target="`popover-students-overview-${data.item.id}`"
                        triggers="hover"
                        placement="right">
                        <template #title>{{$t('testcenter.student_overview')}}</template>

                        <ul class="users">
                            <li
                                class="user"
                                v-for="user of getStudents(data.item.responses)">
                                {{ user }}
                            </li>
                        </ul>
                    </b-popover>

                    {{ data.item.responses.length }}
                    {{ data.item.responses.length === 1 ? $t('testcenter.student') : $t('testcenter.students') }}
                </div>
            </template>

            <template v-slot:cell(progress)="data">
                <b-progress
                    v-b-tooltip.hover
                    title="Voltooide tests">
                    <b-progress-bar
                        :value="data.item.submitted_responses_count"
                        :label="data.item.submitted_responses_count + '/' + data.item.responses.length"
                        :max="data.item.responses.length"
                        :variant="
                            data.item.submitted_responses_count === data.item.responses.length ? 'success' : 'warning'
                        ">
                    </b-progress-bar>
                </b-progress>
            </template>

            <template v-slot:cell(actions)="data">
                <div class="management-actions actions">
                    <b-button
                        class="btn-open"
                        :v-b-tooltip="$t('common.open')"
                        variant="primary-icon-only"
                        @click="openTestIssuingPage(data.item)">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-test"
                        :v-b-tooltip="$t('common.delete')"
                        variant="danger-icon-only"
                        @click="remove(data.item)">
                    </b-button>
                </div>
            </template>

            <template #empty>
                <div class="not-found with-header empty-tests-list">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{$t('testcenter.no_tests_found')}}</div>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
import Design2021ApprenticeDataTable from '../common/design-2021-apprentice-data-table.vue';

export default {
    name: 'design-2021-test-center-index-component',
    components: { Design2021ApprenticeDataTable },
    props: {
        testIssuingsIn: {
            type: Array,
        },
        testsIn: {
            type: Array,
        },
    },
    data() {
        return {
            testIssuings: this.testIssuingsIn,
            fields: [
                {
                    key: 'test.title',
                    label: this.$t('common.name'),
                },
                {
                    key: 'created_at',
                    label: this.$t('testcenter.issued_on'),
                },
                {
                    key: 'teacher',
                    label: this.$t('common.by'),
                },
                {
                    key: 'responses',
                    label: this.$t('common.to'),
                },
                {
                    key: 'progress',
                    label: this.$t('testcenter.progress'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        navigateToTestIssuingWizard() {
            window.location.href = this.routes.testIssuingWizardShow();
        },

        remove(testIssuing) {
            this.alert
                .confirm(this.$t('common.delete'), this.$t('testcenter.confirm_delete_invitation'), this.$t('common.delete'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.testIssuingDelete(testIssuing.id)).then((response) => {
                            this.testIssuings = this.testIssuings.filter(
                                (testIssuing2) => testIssuing2.id !== testIssuing.id,
                            );
                            this.alert.success();
                        });
                    }
                });
        },

        openTestIssuingPage(testIssuing) {
            window.location.href = this.routes.testIssuingShow(testIssuing.id);
        },

        getStudents(users) {
            return users.map((user) => user.user ? user.user.full_name : this.$t('common.removed_user'));
        },
    },
};
</script>

<style scoped lang="scss">
.users-list {
    display: flex;
    align-items: center;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');

    .icon {
        color: $primary;
        font-size: $base-font-size;
    }
}

.progress-bar[aria-valuenow='0'] {
    color: $text-color;
    min-width: fit-content;
    background: $border-color !important;
    margin-left: calc(50% - 15px);
}
</style>
